import styled from 'styled-components';

import { WithThemeProps, pxToRem } from '../../styles';


const Root = styled.div`
	position: relative;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: auto;
	height: 70px;
	padding: 16px;
`;

const IconLayout = styled.div`
	position: relative;
`;

const Counter = styled.span`
	position: absolute;
	top: -6px;
	right: -3px;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	border: 1px solid #fff;
	color: #fff;
	font-size: 10px;
	font-weight: 300;
	padding: 1px;

	${(p: WithThemeProps) => `
		background-color: ${p.theme.palette.dangerPrimary};
	`}
`;

const HeaderLayout = styled.div`
	display: flex;
	width: 412px;
	max-width: 100%;
	justify-content: space-between;
	padding: 10px 24px;
`;

const CloseControl = styled.button`
	font-size: ${pxToRem(12)};
	color: rgba(0, 0, 0, 0.4);
	cursor: pointer;
	transition: color .2s ease-in-out;
	background-color: transparent;
	padding: 0;
	margin: 0;
	border: 0;
	outline: none;

	${(p: WithThemeProps) => `
		&:hover {
			color: ${p.theme.palette.accentPrimary};
		}
	`}
`;

const FooterLayout = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px 24px;
`;

const ContentLayout = styled.div`
	position: relative;
	z-index: 1;
`;

const ItemLayout = styled.div`
	position: relative;
	width: 100%;
`;

const CloseButtonLayout = styled.div`
	position: absolute;
	top: 0;
	right: 8px;
	z-index: 1;
`;


export {
	Root,
	IconLayout,
	Counter,
	HeaderLayout,
	CloseControl,
	FooterLayout,
	ContentLayout,
	ItemLayout,
	CloseButtonLayout,
}
